import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Tipus, Subtipus } from '../types/reclamATC';

export interface ReclamATCState {
  availableTipus: Tipus[];
  tipusState: "uninitialized" | "fetching" | "success" | "error";
  availableSubtipus: Subtipus[];
  subtipusState: "uninitialized" | "fetching" | "success" | "error";
}

const initialState: ReclamATCState = {
  availableTipus: [],
  tipusState: "uninitialized",
  availableSubtipus: [],
  subtipusState: "uninitialized"
};

export const reclamATCSlice = createSlice({
  name: 'reclamATC',
  initialState,
  reducers: {
    fetchTipusRequested: state => {
      state.tipusState = 'fetching';
    },
    fetchSubtipusRequested: state => {
      state.subtipusState = 'fetching';
    },
    tipusReceived: (state, action: PayloadAction<Tipus[]>) => {
      state.availableTipus = action.payload;
      state.tipusState = 'success';
    },
    subtipusReceived: (state, action: PayloadAction<Subtipus[]>) => {
      state.availableSubtipus = action.payload;
      state.subtipusState = 'success';
    },
  }
})

export const actions = reclamATCSlice.actions;

export default reclamATCSlice.reducer;